<template>
    <nuxt-link :to="$prismic.linkResolver(document)">
        <PrismicImage
            :img="image"
            :alt="document.data.title"
            w="350"
        />
        <div class="container-inner">
            <span class="container-inner__title">{{ document.data.title }}</span>

            <div
                v-if="author"
                class="container-inner__author"
            >   
                <span>{{ publicationDate }}</span>
                {{ $translate('by', 'av') }}
                <span>{{ author.data.name }}</span>
            </div>
        </div>
    </nuxt-link>
</template>

<script>
export default {
    props: {
        document: {
            type: Object,
            required: true
        }
    },
    computed: {
        author() {
            if (this.document.data.author) return this.$store.state.authors[ this.document.data.author.id ];
            return false;
        },

        publicationDate() {
            return this.$format.date(this.document.first_publication_date);
        },

        image() {
            if (this.document.data.image.url) {
                return this.document.data.image;
            }

            return {
                dimensions: {
                    width: 1920,
                    height: 960
                },
                alt: this.document.data.image.title,
                copyright: null,
                url: 'https://images.prismic.io/lanen/a534bdf7-7229-4192-8883-4f32f2cb3866_post-default-img.webp?auto=compress,format'
            };
        }
    }
};
</script>

<style lang="scss" scoped>

    a {
        @include flex(between, stretch);
        @include border-radius(5px);
        background: $white;
        box-shadow: $bxs;
        text-decoration: none;
        color: $font;
        overflow: hidden;
        margin-bottom: 20px;
        transition: .1s ease-in-out;
        border: 1px solid #e6e6e6;

        &:hover { box-shadow: 0 4px 10px -2px rgba(0,0,0,.3); }

        img {
            width: 100%;
            height: auto;
            object-fit: cover;
            object-position: left;

            @include device(pad) {
                flex: 1;
                max-width: 150px;
            }
        }

        .container-inner {
            flex: 1;
            text-align: left;
            @include spacing(padding,4);
            @include grid(1, 20px);

            &__title {
                font-family: $fontHeader;
                @include font-size(16px);
            }

            &__author {
                color: $green;
                @include font-size(12px);

                span { font-weight: bold; }
            }
        }
    }

</style>
